import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendJob,
  BackendMutationRetryUnsuccessfulAssetImproveArgs,
} from 'src/types/backend';

type Variables = BackendMutationRetryUnsuccessfulAssetImproveArgs;
type Result = Pick<BackendJob, 'id' | 'status'>;

const MUTATION = gql`
  mutation RetryUnsuccessfulAssetImprove($variationId: ID!, $recomposeRequestId: ID!) {
    retryUnsuccessfulAssetImprove(
      variationId: $variationId
      recomposeRequestId: $recomposeRequestId
    ) {
      id
      status
    }
  }
`;

export const retryUnsuccessfulAssetImprove = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
